import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-ship-batch-cell-renderer',
  templateUrl: './ship-batch-cell-renderer.component.html',
  styleUrls: ['./ship-batch-cell-renderer.component.scss']
})
export class ShipBatchCellRendererComponent implements OnInit,OnDestroy {
  private destroy$ = new Subject<void>();
  params: any;
  iconUrl:string="assets/images/fbm-order-icon/calender-icon.svg";
  className="status-tomorrow-leter";
  constructor(private datePipe:DatePipe) { }
  ngOnInit(): void {
  }

  agInit(params: any): void {
    this.params = params;
    this.getColorObj();
  }

  getColorObj(){
    let ShipDate=this.params.value;
    let current=new Date();
    if (ShipDate.toLowerCase() === "today" && this.params.data.Status!=="Shipped") {
      this.className="status-today";
    }else if (ShipDate.toLowerCase() === "yesterday" && this.params.data.Status!=="Shipped") {
      this.className="status-yesterday";
    }else if ((ShipDate.toLowerCase() === "later day" || ShipDate.toLowerCase() === "tomorrow") && this.params.data.Status!=="Shipped") {
      this.className="status-tomorrow";
    }else if ((ShipDate.toLowerCase() === "today" || ShipDate.toLowerCase() === "later day" || ShipDate.toLowerCase() === "tomorrow" || ShipDate.toLowerCase() === "yesterday") && this.params.data.Status==="Shipped") {
      this.className="status-tomorrow";
    }else if (new Date(ShipDate)<new Date(current.setDate(current.getDate()-1)) && this.params.data.Status==="Shipped") {
      this.params.value=this.datePipe.transform(this.params.value,"MM/dd/YYYY");
      this.className="status-tomorrow";
    }else if (new Date(ShipDate)<new Date(current.setDate(current.getDate()-1)) && this.params.data.Status!=="Shipped") {
      this.params.value=this.datePipe.transform(this.params.value,"MM/dd/YYYY");
      this.className="status-yesterday";
    }else{
      this.params.value=this.datePipe.transform(this.params.value,"MM/dd/YYYY");
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
